import { useEffect, useMemo, useState } from "react";
import { profileTypeEndPoint, profileTypeEnum, tableMapData } from "../ProfileHeader/profile-enum";
import { toast } from "react-toastify";
import axios from "axios";
import ReactTableTrademo from "@shared/trademo-datatable/react-table-trademo";
import ReactTooltip from "react-tooltip";
import ReactCountryFlag from "react-country-flag";
import nodataimage from "@assets/images/common/no-data.png";
import commaFormat from "@utils/commaFormat";
import { getIntelUrl } from "@utils/intelUrl";
import { ExternalLink, Info } from "react-feather";
import { Button, Modal } from "react-bootstrap";
import styles from "./ProfileTable.module.scss";
import { CLOUDINARY_INTEL_BASE_URL } from "@utils/enum";
import LoadingSkeleton from "@shared/LoadingSkeleton";
import TabelRedirectionColumn from "./TabelRedirectionColumn";
import RedirectProfile from "@shared/country-components/redirect-profile";
import { createCountryRedirectUrl, generateTrackingObject, getRedirectProfileType } from "@core/global/global-country-functions";
import { handleDownloadError, isJsonResponse } from "@utils/utils";
import localStorageService from "@core/services/local-storage.service";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { redirectingProfileEnum } from "@core/global/global-country-dictionary";
import moment from "moment";
import TradingPartnerGraph from "@shared/country-components/trading-partner-graph";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import { getUserActivePlan } from "@helpers/profileHelper";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import { SearchInput } from "@components/templates/SearchInput";
import { CountryCodeOneToOneMap, countryDetails, DATASET_TYPE_MAPPING, getDatasetNameByDataSource } from "@core/dictionary/global";

// The backend answers a failed download with a JSON { status, message } body -- sometimes with a
// 200 status (e.g. "No data found to download") -- so anything JSON is an error, not a spreadsheet.
const saveDownloadResponse = (request, fileName) => {
  if (request.status !== 200 || isJsonResponse(request)) {
    handleDownloadError(request);
    return;
  }
  const contentTypeHeader = request.getResponseHeader("Content-Type");
  const file = new Blob([request.response], { type: contentTypeHeader });
  const url = window.URL.createObjectURL(file);
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.href = url;
  a.download = fileName;
  a.click();
};

export const creditCostDetails = {
  "HS codes": 1,
  VOCCs: 5,
  NVOCCs: 5,
  "Freight Forwarders": 5,
  "Trading Partners": 5,
  Vessels: 1,
  Consignees: 5,
  Shippers: 5,
};

const ProfileTable = ({ tableName = "VOCC", tabType, category, subCategory, callTrendingPartners, isLoaderActive, tradingPartnerData, tradingPartnerCount, sortOrderValue, tradingPartnerMustNotInclude, tradingPartnerRange, setTradingPartnerRange, profileName, profileType, profileId, selectedTradingPartner, setSelectedTradingPartner, clearSelectedTradingPartner, setClearSelectedTradingPartner, tradingPartnerCurrentPage, setTradingPartnerCurrentPage, downloadEvent, dataSource = "US-IMORTS", viewShipmentsEvent, companyRedirectionEvent, profileRedirectionId = "", isParentSubs, hideShipment, hideDataSource, hideCountry, companyName, globalPlan, dataSourceColumnHeading, searchValue, hsCodeSearchValue, onSearchHandler, onHsCodeSearchHandler, isSalesForce }) => {
  const [tradingPartnerPerPage, setTradingPartnerPerPage] = useState(10);
  const { search: searchUrlParams } = useLocation();
  const [showTradingPartnerDownloadConfirmation, setShowTradingPartnerDownloadConfirmation] = useState(false);
  const [showDownloadShipmentModal, setShowDownloadShipmentModal] = useState(false);
  const countDetails = useSelector((state) => state.companyProfile?.countDetails);
  const urlParams = new URLSearchParams(searchUrlParams);
  const mergedID = urlParams.get("mergedID");
  const tab = urlParams.get("tab");
  const profile_name = urlParams.get("profileName");
  const isFreightForwarder = useSelector((state) => state?.logisticsProfile?.isFreightForwarder);
  const [isRankActive, setIsRankActive] = useState(true);
  const [isNetworkActive, setIsNetworkActive] = useState(false);
  const creditDetails = useSelector((state) => state.userDetails.creditDetails);
  const isOnlyMirrorSubscribed = creditDetails?.data?.filter((item) => item?.product_id !== "trademo_MC" && item.navigate !== "upgrade").every((dataset) => dataset?.is_active && countryDetails[dataset?.product_id]?.name?.toLowerCase()?.includes("mirror"));

  useEffect(() => {
    setIsNetworkActive(false);
    setIsRankActive(true);
  }, [tableName]);

  const redirectToShipments = (dataSource, rowId, countryCode) => {
    if (!dataSource) return;
    let payloadCategory = getRedirectProfileType(category);
    if (!!isFreightForwarder && payloadCategory === redirectingProfileEnum.nvocc.key) {
      payloadCategory = redirectingProfileEnum.freightForwarder.key;
    }
    let payloadSubCategory = getRedirectProfileType(tableMapData?.[subCategory]?.partnerType?.[category] || subCategory);
    let redirectUrl = "";
    if (globalPlan) {
      redirectUrl = createCountryRedirectUrl(dataSource);
    } else {
      const words = dataSource.split(" ");
      const lastWord = words[words.length - 1];
      redirectUrl = createCountryRedirectUrl(countryCode?.toLowerCase(), lastWord);
    }

    let url = getIntelUrl() + `${redirectUrl}?redirectingFrom=${profileType}&redirectingProfile=${payloadCategory}&redirectingProfileIds=${profileRedirectionId}&profileName=${profileName}&redirectingProfilePartner=${payloadSubCategory}&redirectingProfilePartnerIds=${rowId}&profileId=${profileId}`;
    if (countDetails?.is_parent_company) {
      url += `&isSubsidiaryIncluded=${isParentSubs}`;
    }
    if (mergedID) {
      url += `&isMerged=true&mergedID=${mergedID}`;
      url += `&companyName=${companyName}`;
    }
    if (tab) {
      url += `&tab=${tab}`;
    }
    window.open(url, "_blank");
    viewShipmentsEvent();
  };

  const tradingPartnercolumns = useMemo(() => {
    let tradeColumn = [
      {
        name: "S No.",
        selector: "s_no",
        sortable: false,
        minWidth: "60px",
        maxWidth: "60px",
      },
      {
        name: tableName,
        sortable: false,
        wrap: true,
        maxWidth: "800px",
        minWidth: "400px",
        selector: (row) => (
          <div>
            {tableMapData[subCategory]?.redirectionType === profileTypeEnum.company ? <TabelRedirectionColumn tabType={tabType} companyId={row._id} companyName={row.key} hsDescription={row.description ?? ""} dataSource={row.data_source_list} rowData={row} subCategory={subCategory} isRedirect={tableMapData[subCategory]?.isRedirect} isRedirectCallingSlug={tableMapData[subCategory]?.isRedirectCallingSlug} redirectEvent={companyRedirectionEvent} globalPlan={globalPlan} isSalesForce={isSalesForce} /> : <RedirectProfile rowData={row} isCompany={true} profileType={tableMapData[subCategory]?.profileType} profileId={row._id} slug={row.slug} entityId={row.entity_id} profileName={row.key} dataSource={dataSource} redirectEvent globalPlan={globalPlan} isSalesForce={isSalesForce} />}

            {!profile_name && profileType === "company" && tableName !== "HS codes" && (
              <div>
                {Array.isArray(row.country_list) && row.country_list.length > 0
                  ? row.country_list.map((data) => {
                      const countryName = data?.country || "NA";
                      const countryCode = data?.country_code;

                      return (
                        <p className={styles.countryName} key={countryCode || countryName}>
                          {countryCode ? (
                            <span>
                              <span className="my-auto">
                                <ReactCountryFlag className="mr-2 country_flag" countryCode={countryCode} svg />
                              </span>
                              {countryName}
                            </span>
                          ) : (
                            "NA"
                          )}
                        </p>
                      );
                    })
                  : "NA"}
              </div>
            )}
          </div>
        ),
      },
    ];
    if (!hideCountry && profile_name) {
      tradeColumn.push({
        name: "Country",
        sortable: false,
        grow: 1,
        selector: (row) => (
          <div>
            {row.country_list && Array.isArray(row.country_list) && row.country_list.length
              ? row.country_list.map((data) => {
                  return (
                    <p className={styles.countryName} key={data.country_code}>
                      {" "}
                      {!!data && !!data.country && data.country !== "" ? (
                        <span>
                          <span className="my-auto">
                            {}
                            <ReactCountryFlag className="mr-2 country_flag" countryCode={data.country_code} svg />
                          </span>
                          {data.country}
                        </span>
                      ) : (
                        "NA"
                      )}{" "}
                    </p>
                  );
                })
              : "NA"}
          </div>
        ),
      });
    }

    if (!hideShipment && !globalPlan) {
      tradeColumn.push({
        name: dataSourceColumnHeading || "Total Shipments Traded",
        selector: (row) => (row.doc_count ? commaFormat(row.doc_count) : "NA"),
        sortable: true,
        grow: 1,
      });
    }

    if (!profile_name && profileType === "company" && tableName !== "HS codes") {
      tradeColumn.push({
        name: "First Shipment Date",
        selector: (row) => (row.first_shipment_date ? moment(row.first_shipment_date).format("MMM DD, YYYY") : "NA"),
        sortable: false,
      });
    }
    if (!profile_name && profileType === "company" && tableName !== "HS codes") {
      tradeColumn.push({
        name: "Latest Shipment Date",
        selector: (row) => (row.last_shipment_date ? moment(row.last_shipment_date).format("MMM DD, YYYY") : "NA"),
        sortable: false,
      });
    }
    if (!hideDataSource && !globalPlan && !isOnlyMirrorSubscribed) {
      tradeColumn.push({
        name: "Data Source and Shipments Traded",
        sortable: false,
        minWidth: "300px",
        selector: (row) => (
          <div className="text-capitalize">
            {!!row.data_source_list && row.data_source_list.length !== 0 ? (
              <div className="d-flex">
                {row.data_source_list.map((item) => {
                  const isRedirect = tableMapData[subCategory]?.isRedirect ?? true;
                  return isRedirect ? (
                    <span
                      className={`${styles.customPill} ${isSalesForce ? "tw-cursor-not-allowed tw-pr-3" : "tw-cursor-pointer"} my-1 tw-flex tw-items-center tw-px-1`}
                      key={item.key}
                      onClick={
                        isSalesForce
                          ? () => {
                              return;
                            }
                          : () => redirectToShipments(item?.key, row?._id, item?.countryCode)
                      }>
                      <ReactCountryFlag className="mx-2 country_flag" countryCode={CountryCodeOneToOneMap[item.countryCode.toLowerCase()] ? CountryCodeOneToOneMap[item.countryCode.toLowerCase()] : item.countryCode} svg data-for="countryname2" />
                      <ReactTooltip className="trademo-tooltip text-capitalize" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="left" id="countryname2" />
                      {(item.key && getDatasetNameByDataSource(item.key)) || `${item.key} ${DATASET_TYPE_MAPPING[item.countryCode.toLowerCase()] || ""}`} - {commaFormat(item.doc_count)}
                      {isRedirect && !isSalesForce ? <ExternalLink color="#6F08F1" size={16} className="mx-2 icon-btn" /> : null}
                    </span>
                  ) : (
                    <span className={`${styles.customPill} my-1 tw-flex tw-items-center`} key={item.key}>
                      <ReactCountryFlag className="mx-2 country_flag" countryCode={item.countryCode} svg data-for="countryname2" />
                      <ReactTooltip className="trademo-tooltip text-capitalize" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="left" id="countryname2" />
                      {item.key && item.key.toLowerCase() === "us imports" ? "US Imports" : item.key && item.key.toLowerCase() === "us exports" ? "US Exports" : item.key} - {commaFormat(item.doc_count)}
                    </span>
                  );
                })}
              </div>
            ) : null}
          </div>
        ),
      });
    }
    if (globalPlan) {
      tradeColumn.push({
        name: "Total Shipments Traded",
        selector: (row) => (
          <span className={`${styles.customPill} cursor-pointer my-1`} onClick={() => redirectToShipments("global", row?._id, "global data")}>
            {commaFormat(row?.doc_count)}
            {!hideDataSource && <ExternalLink color="#6F08F1" size={16} className="mx-2 icon-btn" />}
          </span>
        ),
        sortable: true,
        grow: 2,
      });
    }
    return tradeColumn;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableName, tradingPartnerData]);

  useEffect(() => {
    callTrendingPartners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category, subCategory, isParentSubs]);

  const handleTradingPartnerPerRowsChange = (data) => {
    setTradingPartnerPerPage(data);
  };

  const handleTradingPartnerPageChange = (data) => {
    if (tradingPartnerMustNotInclude.length >= tradingPartnerCount) {
      return false;
    }
    const requiredValue = data * tradingPartnerPerPage;
    if (!(!!tradingPartnerData[requiredValue + 1] && tradingPartnerData[requiredValue + 1] !== "")) {
      callTrendingPartners(tradingPartnerData, tradingPartnerMustNotInclude, sortOrderValue, true);
    }
    setTradingPartnerCurrentPage(data);
  };

  const getFileName = () => {
    let prefix = "company_profile_";
    switch (profileType) {
      case "port": {
        prefix = "port_profile_" + tableName.toLowerCase().replace(/\s+/g, "_") + "_";
        return prefix + moment.utc().format("DD-MM-YYYY") + "_" + new Date().getTime();
      }
      case "trade_region": {
        prefix = "trade_lane_profile_" + tableName.toLowerCase().replace(/\s+/g, "_") + "_";
        return prefix + moment.utc().format("DD-MM-YYYY") + "_" + new Date().getTime();
      }
      case "logistics": {
        prefix = "logistic_company_profile_" + tableName.toLowerCase().replace(/\s+/g, "_") + "_";
        return prefix + moment.utc().format("DD-MM-YYYY") + "_" + new Date().getTime();
      }
      default: {
        prefix = "company_profile_" + tableName.toLowerCase().replace(/\s+/g, "_") + "_";
        return prefix + moment.utc().format("DD-MM-YYYY") + "_" + new Date().getTime();
      }
    }
  };

  const selectedTradingPartnerDownload = () => {
    if (selectedTradingPartner && selectedTradingPartner.length === 0) return;
    const requestObject = {
      profile_type: profileType,
      _id: profileId,
      category: category,
      sub_category: subCategory,
      map_type: "",
      order: sortOrderValue,
      download: true,
      data_download: [...selectedTradingPartner],
      email: false,
      file_name: `${getFileName()}.xlsx`,
      slug: profileName,
      isSubsidiaryIncluded: isParentSubs,
    };
    const request = new XMLHttpRequest();
    request.open("POST", profileTypeEndPoint.downloadProfileExcel, true);
    request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
    request.responseType = "blob";
    request.setRequestHeader("sessionId", localStorageService.getSessionID());
    request.setRequestHeader("ssoToken", localStorageService.getAccessToken());
    request.onload = () => saveDownloadResponse(request, getFileName() + ".xlsx");
    request.send(JSON.stringify(requestObject), this);
  };

  const downloadTradingPartnetPopup = () => {
    setShowDownloadShipmentModal(false);
    const requestObject = {
      download: true,
      email: false,
      from: tradingPartnerRange.from - 1,
      size: tradingPartnerRange.to - tradingPartnerRange.from + 1,
      profile_type: profileType,
      _id: profileId,
      category: category,
      sub_category: subCategory,
      map_type: "",
      order: sortOrderValue,
      slug: profileName,
      isSubsidiaryIncluded: isParentSubs,
    };
    if (mergedID) {
      requestObject.isMerged = true;
      requestObject.mergedID = mergedID;
    }
    if (tradingPartnerRange.to - tradingPartnerRange.from < 500) {
      requestObject.file_name = `${getFileName()}.xlsx`;
    } else {
      requestObject.email = true;
      requestObject.file_name = `${getFileName()}.xlsx`;
      axios
        .post(profileTypeEndPoint.downloadProfileExcel, requestObject)
        .then((res) => toast.success(res && res.data && res.data.message ? res.data.message : "Success"))
        .catch((error) => toast.error(error?.response?.data?.message ?? "Something went wrong. Please try again."));
      return;
    }
    const request = new XMLHttpRequest();
    request.open("POST", profileTypeEndPoint.downloadProfileExcel, true);
    request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
    request.responseType = "blob";
    request.setRequestHeader("sessionId", localStorageService.getSessionID());
    request.setRequestHeader("ssoToken", localStorageService.getAccessToken());
    request.onload = () => saveDownloadResponse(request, getFileName() + ".xlsx");
    request.send(JSON.stringify(requestObject), this);
    return;
  };

  return (
    <div>
      <div className="container-fluid tabs-first">
        <div className={`${tableName === "Trading Partners" ? "tw-flex tw-flex-col" : "row"}`}>
          {selectedTradingPartner && selectedTradingPartner.length ? (
            <div className={`tw-w-fit selected-state-row d-flex align-items-center selected-top-box px-1 mt-3 mb-1 ml-2`}>
              <span className="mx-1">
                {selectedTradingPartner.length > 0 ? (
                  <span className="selected-search-count d-flex align-items-center">
                    <span className={`row-select-count mr-1 ${selectedTradingPartner.length > 9 ? "padding" : "extra-padding"}`}>{selectedTradingPartner.length}</span>
                    <span>{selectedTradingPartner.length === 1 ? `${tableName} selected` : `${tableName} selected`}</span>
                  </span>
                ) : null}
              </span>
              <span className="vr mx-1" />
              <span
                className="mx-1 d-flex cursor-pointer align-items-center"
                onClick={() => {
                  setShowTradingPartnerDownloadConfirmation(true);
                  downloadEvent();
                }}>
                <img className="pr-1" src={`${CLOUDINARY_INTEL_BASE_URL}/v1657875670/intel/Importer-Exporter_Tab/leftbar_icon_download_fqdhxy.svg`} alt="Download Icon" />
                <span>Download</span>
              </span>
              <span
                className="mx-1 d-flex cursor-pointer align-items-center"
                onClick={() => {
                  setSelectedTradingPartner([]);
                  setClearSelectedTradingPartner(true);
                }}>
                <img className="pr-1" src={`${CLOUDINARY_INTEL_BASE_URL}/v1657875752/intel/Importer-Exporter_Tab/leftbar_icon_close_jl6z6l.svg`} alt="Clear Icon" />
                <span>Clear</span>
              </span>
            </div>
          ) : null}
          {selectedTradingPartner && selectedTradingPartner.length === 0 ? (
            <div className={`tw-flex ${tableName === "Trading Partners" ? "tw-justify-between" : ""}`}>
              {tableName === "Trading Partners" && (
                <div className="trends-radio-btn text-center d-flex align-items-center tw-h-fit tw-mt-4">
                  <label
                    className={`d-flex align-items-center cursor-pointer trends-radio-btn-rankingtab-border  ${isRankActive ? "selected trends-radio-btn-rankingtab" : "non-selected"}`}
                    onClick={() => {
                      setIsRankActive(true);
                      setIsNetworkActive(false);
                      trademoTrackingEvents(trackingEventDictionary.companyProfilePageTradingPartnerRankTab, generateTrackingObject(dataSource, window.Location.pathname, getUserActivePlan()));
                    }}>
                    <img src={!isRankActive ? "https://res.cloudinary.com/drzta9shk/image/upload/v1673258664/intel/icons/ranking_purple_tkdu0l.svg" : "https://res.cloudinary.com/drzta9shk/image/upload/v1673258664/intel/icons/ranking_gray_glulyc.svg"} alt="graph-icon" />
                    Rank
                  </label>

                  <label
                    className={`d-flex align-items-center cursor-pointer trends-radio-btn-trendstab ${isNetworkActive ? "selected trends-radio-btn-trendstab" : "non-selected"}`}
                    onClick={() => {
                      setIsNetworkActive(true);
                      setIsRankActive(false);
                      trademoTrackingEvents(trackingEventDictionary.companyProfilePageTradingPartnerNetworkTab, generateTrackingObject(dataSource, window.Location.pathname, getUserActivePlan()));
                    }}>
                    <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1657875614/intel/Importer-Exporter_Tab/rightbat_icon_graph_inactive_c0vguj.svg" alt="graph-icon" />
                    Network
                  </label>
                </div>
              )}
              {!isNetworkActive && tableName === "Trading Partners" ? (
                <div className="col-md-5 d-flex tw-mr-auto tw-mt-4">
                  <SearchInput placeholder="Search company name" size="medium" value={searchValue} onSearchHandler={onSearchHandler} />
                </div>
              ) : (
                <></>
              )}
              {!isNetworkActive && !isSalesForce && (
                <div>
                  <button
                    id="shipment-default-download-excel-button"
                    className={`trademo-side-filter btn btn-secondary ${["HS codes", "NVOCCs", "Freight Forwarders", "VOCCs"].includes(tableName) ? "tw-ml-0" : "ml-2"} mt-3 d-flex align-items-center p-3`}
                    type="button"
                    onClick={() => {
                      setShowDownloadShipmentModal(true);
                      downloadEvent();
                    }}>
                    <img className="pr-2" src={`${CLOUDINARY_INTEL_BASE_URL}/v1657875614/intel/Importer-Exporter_Tab/rightbar_icon_download_p8iyms.svg`} alt="Download Icon" />
                    <span>Download</span>
                  </button>
                </div>
              )}
              {!isNetworkActive && tableName === "HS codes" ? (
                <div className="col-md-5 d-flex tw-mr-auto tw-mt-4">
                  <SearchInput placeholder="Search HS Codes" size="medium" value={hsCodeSearchValue} onSearchHandler={onHsCodeSearchHandler} />
                </div>
              ) : (
                <></>
              )}
            </div>
          ) : null}
          <div className="col-xl-12 col-md-6 mb-4 px-0">
            <div className={`card ${styles.trademoPlainCard} w-100`}>
              <div className="card-body py-2 px-0">
                {isLoaderActive || tradingPartnerData === null ? (
                  <>
                    <LoadingSkeleton lines={1} lineHeight="30px" width="8%" shape="rectangle" margin={"1rem 0 0 0"} />
                    <LoadingSkeleton lines={13} lineHeight="30px" width="100%" shape="rectangle" />
                  </>
                ) : (
                  <div className={`p-0 m-0 tw-w-full`}>
                    {!!tradingPartnercolumns && !!tradingPartnerData && tradingPartnerData.length !== 0 && isRankActive ? (
                      <div className="w-100">
                        <div className={`col-12 p-0 ${styles.simpleDataTable} tw-border tw-border-gray-300 tw-rounded-lg`}>
                          <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" />
                          <ReactTableTrademo
                            tableName={tableName}
                            columns={tradingPartnercolumns}
                            data={tradingPartnerData}
                            onSelectedRowsChange={(data) => {
                              setClearSelectedTradingPartner(false);
                              setSelectedTradingPartner([...data]);
                            }}
                            clearSelectedRows={clearSelectedTradingPartner}
                            paginationTotalRows={tradingPartnerCount}
                            paginationPerPage={tradingPartnerPerPage}
                            paginationDefaultPage={tradingPartnerCurrentPage}
                            selectedData={selectedTradingPartner}
                            onChangeRowsPerPage={handleTradingPartnerPerRowsChange}
                            onTableObjectChange={(data) => {
                              setTradingPartnerCurrentPage(data.currentPage + 1);
                              setTradingPartnerPerPage(data.perPage);
                            }}
                            onChangePage={handleTradingPartnerPageChange}
                            hideSorting={true}
                            onSort={(e, sortDirection) => {
                              setTradingPartnerCurrentPage(1);
                              setSelectedTradingPartner([]);
                              callTrendingPartners([], [], sortDirection);
                            }}
                            defaultSortField={"total_shipments"}
                            defaultSortAsc={sortOrderValue === "desc" ? false : true}
                            sortOrderValue={sortOrderValue}
                            hideSelection={isSalesForce ? true : false}
                            shipmentDefaultSortValue={[{ columnKey: "total_shipments", value: "total_shipments" }]}
                          />
                        </div>
                      </div>
                    ) : !!tradingPartnercolumns && !!tradingPartnerData && tradingPartnerData.length === 0 && isLoaderActive !== true && isParentSubs && !isNetworkActive ? (
                      <div className="d-block text-center w-100 p-5">
                        <div className={`card px-2 pt-4 pb-1 w-25 m-auto ${styles.noDataCard} border-0`}>
                          <div className="text-center card-body p-2">
                            <div className="header-image">
                              <img className="img-fluid" src={nodataimage} alt="..." />
                            </div>
                            <p className="mt-4">No {tableName} profile found.</p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      !isNetworkActive && (
                        <div className="label-md text-center no-shipment-data">
                          <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1686817425/intel/icons/brightness_alert_lwi77k.svg" />
                          <p>We can't find any shipments for this company. There may be shipments being imported by its subsidiaries. Please switch on the "Include Subsidiaries Data" option above.</p>
                        </div>
                      )
                    )}
                    {isNetworkActive === true ? (
                      <div>
                        <TradingPartnerGraph profileType={profileType} profileId={profileId} category={category} profileName={profileName} subCategory={subCategory} companyName={companyName} sortOrderValue={sortOrderValue} isParentSubs={isParentSubs} type={category.toLocaleUpperCase()} />
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="md"
        centered
        show={showDownloadShipmentModal}
        onHide={() => {
          setShowDownloadShipmentModal(false);
          setTradingPartnerRange({ from: 1, to: tradingPartnerCount < 100 ? tradingPartnerCount : 100 });
        }}
        animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Download {tableName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row m-0">
            <div className="col-6 p-0">
              <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" />
              <span className="label-value line-height-32">
                Select {tableName} by S.No <Info className="ml-1 cursor-pointer" color="#8C8C8C" size={13} data-tip="If selected count is more than 500, shipments are emailed." />
              </span>
            </div>
            <div className="col-6 p-0">
              <div className="row m-0">
                <div className="col-5 pr-0">
                  <input
                    name="advanceSearchEntireBillLading"
                    className="download-input-field"
                    placeholder="From"
                    type="number"
                    value={tradingPartnerRange.from}
                    onChange={(e) => {
                      let tempRange = { ...tradingPartnerRange };
                      tempRange.from = parseInt(e.target.value) > tradingPartnerCount ? tradingPartnerCount : parseInt(e.target.value);
                      setTradingPartnerRange(tempRange);
                    }}
                    min={1}
                  />
                </div>
                <div className="col-2">
                  <span className="label-value line-height-32">to</span>
                </div>
                <div className="col-5 pr-0">
                  <input
                    name="advanceSearchEntireBillLading"
                    className="download-input-field"
                    placeholder="To"
                    type="number"
                    value={tradingPartnerRange.to}
                    min={1}
                    onChange={(e) => {
                      let tempRange = { ...tradingPartnerRange };
                      tempRange.to = parseInt(e.target.value) > tradingPartnerCount ? tradingPartnerCount : parseInt(e.target.value);
                      setTradingPartnerRange(tempRange);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2"
            onClick={() => {
              setShowDownloadShipmentModal(false);
              setTradingPartnerRange({ from: 1, to: tradingPartnerCount < 100 ? tradingPartnerCount : 100 });
            }}>
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary btn-sm trademo-new-btn"
            disabled={!tradingPartnerRange.to || !tradingPartnerRange.from || tradingPartnerRange.to < tradingPartnerRange.from}
            onClick={() => {
              if (tableName === "HS codes" || tableName === "Vessels") {
                if (selectedTradingPartner.length) {
                  selectedTradingPartnerDownload();
                } else {
                  downloadTradingPartnetPopup();
                }
              } else {
                setShowTradingPartnerDownloadConfirmation(true);
                setShowDownloadShipmentModal(false);
              }
            }}>
            {tradingPartnerRange.to - tradingPartnerRange.from < 500 ? "Download" : "Email"}
          </button>
        </Modal.Footer>
      </Modal>
      {showTradingPartnerDownloadConfirmation ? (
        <Modal size="md" centered show={true} onHide={() => setShowTradingPartnerDownloadConfirmation(false)}>
          <Modal.Header className="p-2" closeButton>
            <div className="d-flex justify-content-between w-100 align-items-center">
              <div className="ml-2">
                <strong>Confirmation</strong>
              </div>
              <div>
                <Button
                  className="btn btn-primary trademo-new-btn"
                  onClick={
                    selectedTradingPartner.length
                      ? () => {
                          setShowTradingPartnerDownloadConfirmation(false);
                          selectedTradingPartnerDownload();
                        }
                      : () => {
                          downloadTradingPartnetPopup();
                          setShowTradingPartnerDownloadConfirmation(false);
                        }
                  }>
                  Confirm
                </Button>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            You are downloading list of{" "}
            <strong>
              {selectedTradingPartner.length ? selectedTradingPartner.length : tradingPartnerRange.to - tradingPartnerRange.from + 1} {tableName}
            </strong>{" "}
            which will cost you <strong>{selectedTradingPartner.length ? selectedTradingPartner.length * (creditCostDetails[tableName] || 5) : (tradingPartnerRange.to - tradingPartnerRange.from + 1) * 5} Download Credits</strong>.
          </Modal.Body>
        </Modal>
      ) : null}
    </div>
  );
};

export default ProfileTable;
